export default "__VITE_ASSET__DOhr1MoJ__"